<template>

    <div class="container">

        <app-head title="Products" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Products') }}</h1>
            <div class="">
                <inertia-link :href="route('admin.products.create', { })" class="btn btn-primary">
                    {{ __('Erstellen') }}
                </inertia-link>
                <!--       @todo         <inertia-link :href="route('admin.products.import', { })" class="btn btn-primary">
                    {{ __('Produktdaten importieren') }}
                </inertia-link>-->
                <inertia-link :href="route('admin.products.queue', { })" class="btn btn-secondary">
                    {{ __('Import-Queue') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" @reset="reset">

                <!--                <text-input type="search" list="suppliers" label="supplier" v-model="form.supplier_id" />
                                <datalist id="suppliers">
                                    <option :data-value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name }}</option>
                                </datalist>-->

                <!--@todo<autocomplete-input v-model="form.supplier_id" :options="suppliers" label="short_name" />-->

                <select-input label="supplier" v-model="form.supplier_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name }}</option>
                </select-input>
                <select-input label="images" v-model="form.images">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option value="only_with_images">{{ __('Only with images') }}</option>
                    <option value="only_without_images">{{ __('Only without images') }}</option>
                </select-input>
                <select-input label="Status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="enabled">{{ __('Enabled') }}</option>
                    <option value="disabled">{{ __('Disabled') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
                <div class="w-100"></div>
                <div class="d-flex gap-3">
                    <checkbox-input label="top_seller" v-model="form.top_seller" />
                    <!-- @todo <checkbox-input label="group_same_products" v-model="form.group_same_products" />-->
                </div>
                <div class="w-100"></div>
                <multi-select-input
                    v-model="form.categories" 
                    value-consists-of="ALL"
                    :flat="true"
                    sort-value-by="INDEX"
                    :multiple="true" 
                    :options="categoryOptions" 
                    :placeholder="__('Search')"
                    label="categories"
                    />
                <select-input label="categorization" v-model="form.categorization">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option value="mapped">{{ __('Mapped') }}</option>
                    <option value="unmapped">{{ __('Unmapped') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="products.meta" />
            <div>
                <i class="bi bi-download"></i>
                {{ __('Export') }}
                <a :href="getExportUrl('xlsx')">
                    {{ __('XLSX') }}
                </a>
                /
                <a :href="getExportUrl('csv')">
                    {{ __('CSV') }}
                </a>
                /
                <a :href="getExportUrl('ods')">
                    {{ __('ODS') }}
                </a>
            </div>
        </div>

        <div class="card">
            <data-table :items="products.data"
                        :links="products.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="product in products.data" :key="product.id">
                    <td>
                        {{ product.id }}
                    </td>
                    <td class="text-center">
                        <img class="" :src="product.main_image_url" alt="" style="max-height: 50px; max-width: 50px; width: auto;" loading="lazy" />
                    </td>
                    <td class="">
                        <template v-if="product.supplier.logo">
                            <img class="" :src="product.supplier.logo" :alt="product.supplier.name" style="max-height: 20px; width: auto;" />
                        </template>
                        <template v-else>
                            {{ product.supplier.name }}
                        </template>
                    </td>
                    <td class="text-nowrap">
                        {{ product.supplier_pid || '-' }}
                    </td>
                    <td class="">
                        <div v-if="product.deleted_at">
                            {{ product.name }}
                        </div>
                        <inertia-link class="" :href="route('admin.products.edit', product)" v-else>
                            {{ product.name }}
                        </inertia-link>
                    </td>
                    <td>
                        <boolean :value="product.enabled" />
                    </td>
                    <td>
                        {{ product.variants_count || '-' }}
                    </td>
                    <!--                    <td>
                                            <inertia-link :href="route('admin.products.index', {identification_number: product.identification_number})">
                                                {{ product.same_product_from_all_suppliers_count || '-' }}
                                            </inertia-link>
                                        </td>-->
                    <td>
                        <div class="d-grid gap-2">
                            <div v-if="product.categories.length === 0">-</div>
                            <div class="small d-flex flex-wrap gap-1" v-else>
                                <span class="badge bg-secondary text-light" v-for="category in product.categories">
                                    {{ category.name }}
                                </span>
                            </div>

                            <div class="small" v-if="product.supplier_categories.length">
                                <div class="">{{ __('Supplier') }}</div>
                                <div class="d-flex flex-wrap gap-1">
                                    <span class="badge bg-light text-secondary" v-for="supplierCategory in product.supplier_categories">
                                        {{ supplierCategory.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <template v-if="product.manage_stock">
                            <!-- @todo make component-->
                            <span v-if="product.stock_quantity > 0" :title="__('Auf Lager')" class="text-success">
                                <i class="bi bi-circle-fill"></i>
                            </span>
                            <span v-else-if="product.stock_quantity === 0" :title="__('Nicht auf Lager')" class="text-danger">
                                <i class="bi bi-circle-fill"></i>
                            </span>
                            <span v-if="product.stock_quantity === null">-</span>
                            <span v-else>{{ product.stock_quantity | localizeNumber }}</span>
                        </template>
                        <template v-else>
                            {{ __('-') }}
                        </template>
                    </td>
                    <td class="text-nowrap">
                        <div v-if="product.default_price">
                            {{ product.default_price.price | localizeAmount }}
                        </div>
                        <div v-else>
                            <em>{{ __('-') }}</em>
                        </div>
                    </td>
                    <td class="text-end text-nowrap">
                        <template v-if="product.deleted_at">
                            <button type="button" class="btn btn-outline-success" @click="restore(product)">
                                {{ __('Restore') }}
                            </button>
                            <button type="button" class="btn btn-outline-danger" @click="destroyPermanently(product)">
                                {{ __('Destroy permanently') }}
                            </button>
                        </template>

                        <div class="dropdown" v-else>
                            <button class="btn btn-outline-secondary" 
                                    type="button" 
                                    :id="`dropdownMenuProduct-${product.id}`" 
                                    :title="__('Edit')"
                                    data-bs-toggle="dropdown" 
                                    aria-expanded="false">
                                <i class="bi bi-three-dots-vertical"></i>
                                {{ __('Edit') }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-end" :aria-labelledby="`dropdownMenuProduct-${product.id}`">
                                <a :href="route('products.show', {id: product.id, slug: product.slug})" class="dropdown-item" target="_blank">
                                    {{ __('Ansehen') }}
                                </a>
                                <inertia-link :href="route('admin.products.edit', {product})" class="dropdown-item">
                                    {{ __('Bearbeiten') }}
                                </inertia-link>
                                <inertia-link :href="route('admin.products.duplicate', {product})" class="dropdown-item">
                                    {{ __('Duplicate') }}
                                </inertia-link>
                            </div>
                        </div>

                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';

    import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';
    import AutocompleteInput from '@/shared/Inputs/AutocompleteInput';

    import Boolean from '@/shared/Admin/Boolean';

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import Results from '@/shared/Admin/Results';

    export default {

        props: [
            'filters',
            'products',
            'suppliers',
            'categoryTree',
        ],
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    top_seller: this.filters.top_seller,
                    images: this.filters.images,
                    group_same_products: this.filters.group_same_products,
                    supplier_id: this.filters.supplier_id,
                    categories: this.filters.categories,
                    categorization: this.filters.categorization,
                    supplier_category_id: this.filters.supplier_category_id,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    image: {label: 'Image'},
                    supplier: {label: 'Supplier'},
//                    sku: {label: 'SKU', sortable: 'sku'},
                    supplier_pid: {label: 'AID/PID', sortable: 'supplier_pid', info: 'Supplier PID'},
                    name: {label: 'Name', sortable: 'name'},
                    enabled: {label: 'Enabled', sortable: 'enabled'},
                    variants: {label: 'Variants', sortable: 'variants_count'},
                    // same_product_from_all_suppliers_count: {label: 'Offers', sortable: 'same_product_from_all_suppliers_count'},
                    categories: {label: 'Categories'},
//                    supplier_categories: {label: 'Supplier Categories'},
                    stock_quantity: {label: 'Stock quantity', sortable: 'stock_quantity'},
                    price: {label: 'Price'},
                },
                categoryOptions: this.categoryTree,
            }
        },
        components: {
            TextInput,
            SelectInput,
            CheckboxInput,
            MultiSelectInput,
            AutocompleteInput,
            DataTable,
            DataTableRow,
            SearchFilter,
            Results,
            Boolean,
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.products.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null);
            },
            destroyPermanently(product) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.products.destroy-permanently', product.id));
                }
            },
            restore(product) {
                this.$inertia.get(this.route('admin.products.restore', product.id));
            },
            getExportUrl(format) {
                return this.route('admin.products.export', {format: format, ...this.filters});
            }
        },
        computed: {

        },
    }
</script>